
export const REQUEST_SUB_LINKS = {
    orderRequest: {
        id: 1
        , link: 'Requests/MyRequest'
    }
    ,quotationRequest: {
        id: 2
        , link: 'Requests/QuotationRequest'
    }
    ,approvalRequest: {
        id: 3
        , link: 'Requests/ApprovalRequest'
    }
    ,coverageRequest: {
        id: 4
        , link: 'Requests/CoverageRequest'
    },
    allRequest: {
        id: 5
        , link: 'Requests/AllRequest'
    },
}

export const RAISE_REQUEST_ORDER_BASE = "RaiseRequest/Order/";

export const RAISE_REQUEST_LINKS = {
    orderRequest: {
        id: 1
        , link: 'MyRequest/' + RAISE_REQUEST_ORDER_BASE
    }
    , quotationRequest: {
        id: 2
        , link: 'QuotationRequest/' + RAISE_REQUEST_ORDER_BASE
    }
    , approvalRequest: {
        id: 3
        , link: 'ApprovalRequest/' + RAISE_REQUEST_ORDER_BASE
    }
    , coverageRequest: {
        id: 4
        , link: 'CoverageRequest/' + RAISE_REQUEST_ORDER_BASE
    },
    allRequest: {
        id: 5
        , link: 'AllRequest/' + RAISE_REQUEST_ORDER_BASE
    },
}

export const INVENTORY_REQUEST_LINK = {
    inventoryCircuitDetails: {
        id: 1
        , link: 'Details/'
    }
}

export const REQUEST_TYPE = {
    orderRequest: "MyRequest",
    quotationRequest: "QuotationRequest",
    approvalRequest: "ApprovalRequest",
    allRequest: "AllRequest",
    coverageRequest: "CoverageRequest",
    request: "Request",
    InternationalAccess:"International Access"
}

export const REQUEST_TAB_NAME = {
    allOrderRequest: "All Requests",
    myRequest: "My Requests",
    approvalRequest: "For Approval",
    quotationRequest: "Quotation Requests"
}

export const GET_REQUEST_HEADER_TITLE = [
    { Key: 4, Value: "Change User Request" },
    { Key: 14, Value: "Change Vendor Request" },
    { Key: 40, Value: "International Access Request" },
    { Key: 33, Value: "Replace/Upgrade Device Request" },
    { Key: 35, Value: "Accessory Request" },
    { Key: 7, Value: "Terminate Subscription Request" },
    { Key: 11, Value: "Port-Out Request" },
    { Key: 15, Value: "Other Request" },
    { Key: 9, Value: "New Mobile Subscription Request" },
    { Key: 44, Value: "SIM and Device Request" },
    { Key: 45, Value: "New Mobile Device Request" },
    { Key: 46, Value: "Wifi Dongle and Data Card Request" },
    { Key: 47, Value: "SIM and Device (BSA) Request" },
    { Key: 48, Value: "SIM only (BSA) Request" },
    { Key: 49, Value: "Multi SIM (BSA) Request" },
    { Key: 50, Value: "Wifi, Dongle and Data Card (BIN) Request" },
    { Key: 51, Value: "Voice SIM (BIN) Request" },
    { Key: 52, Value: "Wifi Dongle, Data Card and Voice SIM (BIN) Request" },
    { Key: 12, Value: "Port-In Request" },
    { Key: 23, Value: "Other - Other Request" },
    { Key: 17, Value: "Other - SIM Activation Request" },
    { Key: 37, Value: "Other - Change Number Request" },
    { Key: 19, Value: "Other - PUK Code Request" },
    { Key: 42, Value: "Other - SIM Replacement Request" },
    { Key: 43, Value: "Other - Change of Plan Request" },
    { Key: 36, Value: "Other - Enable Hotspot Request" },
    { Key: 41, Value: "International Access - Calling Access Request" },
    { Key: 38, Value: "Other - Suspend/Resume Service Request" },
    { Key: 27, Value: "New Circuit Request" },
    { Key: 25, Value: "Terminate Circuit Request" },
    { Key: 28, Value: "New Quotation Request"},
    { Key: 29, Value: "Change Vendor Request" },
    { Key: 26, Value: "Other Request" },
    { Key: 32, Value: "Other - Other Request" },
    { Key: 31, Value: "Other - Change Location Address Request" },
    { Key: 30, Value: "Other - Upgrade Circuit Request" },
    { Key: 24, Value: "Update Plan Request" },
]


export const REQUEST_TYPES_ID = {
    //wireless requests
    newCircuitOrder: 1
    , manageExisting: 2
    , newOrder: 3
    , changeUser: 4
    , changePricePlan: 5
    , simReplacement: 6
    , subscriptionCancellation: 7
    , newMobile: 9
    , terminate: 10
    , portOut: 11
    , portIn: 12
    , deviceReplacement: 33
    , changeVendor: 14
    , otherRequestOther: 15
    , accessory: 35
    , intlRoamingAccess: 40
    //Wireline Request
    , updatePlanWireline: 24
    , terminateSubscriptionWireline: 25
    , otherWireline: 26
    , newSubscriptionWireline: 27
    , newQuotation: 28
    , wirelineChangeVendor: 29
    //wireline other request
    , wirelineUpgradeCircuit: 30
    , wirelineChangeLocationAddress: 31
    , wirelineOtherOther: 32

    //other request types
    , newHomeOfficeConnection: 16
    , simActivation: 17
    , roamingActivation: 18
    , pukCode: 19
    , itemizedBillingofCallsReport: 20
    , changeInvoiceAddress: 21
    , moveHOC: 22
    , other: 23
    , changeNumber: 37
    , enableHotspot: 36
    , suspendResumeService: 38
    , CallingAccess: 41
    , otherSIMReplacement: 42
    , otherChangeOfPlan: 43

    //new mobile request types
    , simAndDevice: 44
    , newMobileDevice: 45
    , wifiDongleAndDataCard: 46
    , simAndDeviceBSA: 47
    , simOnlyBSA: 48
    , multiSIMBSA: 49
    , wifiDongleAndDataCardBIN: 50
    , voiceSIMBIN: 51
    , wifiDongleDataCardAndVoiceSIMBIN: 52
};

export const REQUEST_TYPES_LABEL = {
    //wireless requests
    PORTIN: 'Port-In'
    , OTHER: 'Other'
    
};

export const CIRCUIT_CATEGORIES = {
    mobile: 1,
    fixed: 2,
    hoc: 3,
};

export const WIRELESS_CIRCUIT_TYPES = {
    mobileCellPhone: 1,
    dataCard: 2,
    mobileOfficeConnection: 3
}

export const WIRELINE_CIRCUIT_TYPES = {
    DDI: 4,
    PSTN: 5,
    ISDNPRI: 6,
    HomeOfficeConnection: 7,
    DID: 8,
    Internet: 9,
    MPLS: 10,
    Local: 11,
    PrivateLine: 12,
    SIP: 13,
    Voice: 14,
    CableTV: 15,
    LongDistance: 16,
    SIPInbound: 17,
    SIPOutbound: 18,
    Teleconferencing: 19,
    TollFree: 20,
    VoIP: 21,
    MaintenanceServices: 22,
    ProfessionalServices: 23,
}

export const WIRELESS_REQUEST_TYPES_IDS ={
        newCircuitOrder: 1
        , manageExisting: 2
        , newOrder: 3
        , changeUser: 4
        , changePricePlan: 5
        , simReplacement: 6
        , subscriptionCancellation: 7
        , newMobile: 9
        , terminate: 10
        , portOut: 11
        , portIn: 12
        , deviceReplacement: 33
        , changeVendor: 14
        , otherRequestOther: 15
        , accessory: 35
        , intlRoamingAccess: 40
        , newHomeOfficeConnection: 16
        , simActivation: 17
        , roamingActivation: 18
        , pukCode: 19
        , itemizedBillingofCallsReport: 20
        , changeInvoiceAddress: 21
        , moveHOC: 22
        , other: 23
        , changeNumber: 37
        , enableHotspot: 36
        , suspendResumeService: 38
        , CallingAccess:41
        , otherSIMReplacement: 42
        , otherChangeOfPlan: 43
        , simAndDevice: 44
        , newMobileDevice: 45
        , wifiDongleAndDataCard: 46
        , simAndDeviceBSA: 47
        , simOnlyBSA: 48
        , multiSIMBSA: 49
        , wifiDongleAndDataCardBIN: 50
        , voiceSIMBIN: 51
        , wifiDongleDataCardAndVoiceSIMBIN: 52
}

export const WIRELINE_REQUEST_TYPES_ID = {

    //Wireline Request
    updatePlanWireline: 24,
    terminateSubscriptionWireline: 25,
    otherWireline: 26,
    newSubscriptionWireline: 27,
    newQuotation: 28,
    upgradeQuotation: 5,
    wirelineChangeVendor: 29,
    //wireline other request
    wirelineUpgradeCircuit: 30,
    wirelineChangeLocationAddress: 31,
    wirelineOtherOther: 32,

};
export const WIRELESS_REQUEST_TYPES_ID = {
    mobileCellPhone: 1,
    dataCard: 2,
    mobileOfficeConnection: 3,
};

export const ORDER_AUDIT_TYPES = {
    orderCreated: 1,
    commentOrder: 2,
    updateOrder: 3,
    assignOrder: 4,
    approveOrder: 5,
    rejectOrder: 6,
    expiredOrder: 7,
    requestedInBehalf: 8,
    cancelOrder: 9,
    orderSubmitted: 10,
    orderReceiptConfirmed: 11,
    orderCompleted: 12,
};
export const INVALID_CHARS = [
    "-",
    "+",
    ".",
    "e"
];

export const INTEGER_INVALID_CHARS = [
    "-",
    "+",
    "e"
]

export const OTHER_MENU_FILTER = [
    { Key: 21, Value: "Change Invoice Address" },
    { Key: 20, Value: "Itemized Billing of Calls Report" },
    { Key: 22, Value: "Move HOC" },
    { Key: 23, Value: "Other" },
    { Key: 19, Value: "PUK Code" },
    { Key: 18, Value: "Roaming Activation" },
    { Key: 17, Value: "SIM Activation" },
    { Key: 36, Value: "Enable Hotspot" },
    { Key: 37, Value: "Change Number" },
    { Key: 38, Value: "Suspend/Resume Service" },
    { Key: 36, Value: "Enable Hotspot" },
    { Key: 30, Value: 'Upgrade Circuit'},
    { Key: 31, Value: 'Change Location Address' },
    { Key: 42, Value: 'SIM Replacement' },
    { Key: 43, Value: 'Change of Plan' }
];

export const INTERNATIONAL_REQUEST_FILTER = [
   
    { Key: 40, Value: "Roaming Access" },
    { Key: 41, Value: "Calling Access" },

];
export const ORDER_AUDIT_VERBIAGE = { 
    orderCreated: 'Request logged',
    commentOrder: '{name} {commented} on your request',
    deleteCommentOrder: 'Comment was deleted on {yearDayMonth} at {time}',
    updateOrder: '{name} updated on your request',
    assignOrder: 'Request assigned to {name}',
    approveOrder: 'Request approved',
    rejectOrder: 'Request rejected',
    expiredOrder: 'Request expired',
    requestedInBehalf: '{name} raised the request',
    cancelOrder: 'Request cancelled',
    orderSubmitted: 'Order submitted',
    orderReceiptConfirmed: 'Order receipt confirmed',
    orderCompleted: 'Order completed',
    order: 'order'
};
export const REQUEST_LOG_FILTER_BY = {
    requestType: { filter: 'Request', title: 'Request' , subItems: [] },
    other: { filter: 'Other', title: 'Other' },
    owner: { filter: 'Owner', title: 'Owner' },
    status: { filter: 'Status', title: 'Status' },
};


export const REQUEST_LOG_FILTER_BYs = {
    samplecheck: "Roaming Access",
    samplecheck2: "Calling Access",
};


export const REQUEST_STATUS = {
    inProgress: "Waiting for Approval",
    open: "Open",
    inProgressAwaitingToVendor: "In Progress (Awaiting Submission to Vendor)",
    inProgressSubmittedToVendor: "In Progress (Submitted to vendor)",
    isApproved: "Approved"
}

export const REQUEST_STATUS_TXT = {
    forApproval: "For First Level Approval"
}

export const PrimarySecondaryString = {
    primary: "primary",
    secondary: "secondary",
    both: "both"
}
export const PrimarySecondaryInt = {
    primary: 1,
    secondary: 2,
    both: 3
}

export const CODE_DETAIL_ID =
{
    Other: 18,
    Business: 23,
    Personal: 24
}

export const FILE_ATTACHMENT_MODULES = {
    orderCreation: 1,
    orderComments: 2,
    circuitComments: 3,
    equipmentComments: 4,
    disputeComments: 5,
    invoiceComments: 6,
    invoiceFileAttachment: 7,   
    manageUserComments: 8,
    orderDetailsComments: 9,
    quotationDetailsComments: 10,
    planCatalogueComments: 14,
    billingComments: 15,
    contractComments: 16,
    rechargeComments: 17,
    outputComments: 18
}

export const EXTRACT_TEMPLATE_MODULES ={
    genericTemplate: 11,
    chargeMappingTemplate: 12,
    rateCardUploadTemplate: 13,
    debitorCatalogueTemplate: 14,
    hrUploadTemplate: 15,
    articleCatalogueTemplate: 16
    // id for 17-23 is already assigned for invetory templates. Ref: INVENTORY_TEMPLATE
}

export const USER_ROLES_ID = {
    admin: 1,
    analyst: 2,
    reporting: 3,
    client: 4,
    manager: 5,
    lineManager: 6,
    teamLead: 10,
    noAccess: 18,
    supportAdmin: 19
};

export const ORDER_STATUS = {
    waitingForAuthorization: 2,
    rejected: 3,
    approved: 6,
    completed: 1,
    canceled: 15,
    open: 12,
    progress: 9,
    progress_awaiting_submission: 4
};

export const APPROVE_STATUS = {
    pending: 1,
    approved: 2,
    rejected: 3
};
export const ORDER_STATUS_TEXT = [
    { id: 2, value: "WAITING FOR APPROVAL"},
    { id: 3, value: "REJECTED", customClass:"cancelled-status-color" },
    { id: 6, value: "APPROVED", customClass:"approved-status-color"},
    { id: 1, value: "COMPLETED" },
    { id: 15, value: "CANCELLED", customClass:"cancelled-status-color"},
    { id: 12, value: "OPEN" },
    { id: 9, value: "IN PROGRESS (Submitted to vendor)" },
    { id: 14, value: "IN PROGRESS (Submitted to vendor)" },
    { id: 4, value: "IN PROGRESS (Awaiting Submission to vendor)" },
];
export const INPUT_FIELD_TYPE = {
    type:'number'
}

export const POWER_BI_SUBREPORT = "report_5";

export const CSAT_SETTINGS = {
    lbl_title: "TEM Survey",
    questionCount: 4,
    lbl_required: "Required",
    lbl_surveyVerbiage:
        'With this survey, we will be able to evaluate the service that we provide to you! Please note that Very dissatisfied is the lowest score and Very satisfied is the highest score.',
    lbl_completionVerbiage: 'Thank you for completing our survey!',
    lbl_comments: "Comments"
};

export const PURPOSEOFUSEOPTIONS = {
    directLine: "Direct line",
    backupLine: "Backup line",
    specialUseSub: "Special Use Subscription",
    workSub: "Work Subscription"
}

export const DATE_FORMATS = [
    {
      format: "DD/MM/YYYY"
    },
    {
      format: "MM/DD/YYYY"
    },
    {
      format: "YYYY/MM/DD"
    },
    {
        format: "MMM DD, YYYY"
    },
    {
        format: "MMMM DD, YYYY"
    },
    {
        format: "DD MMM, YYYY"
    },
    {
        format: "DD MMMM, YYYY"
    },
  ];

export const DATE_FORMATS_MESSAGE = {
    Message:"Changing the default date format will affect all of the date fields available in ATEM across all users.",
    SeconeMessage:'If you want to proceed on changing the default date format please select "Confirm", otherwise "Discard".'
}

export const TIME_ZONE_MESSAGE = {
    Message: "Changing the default time zone will affect all of the time displayed available in ATEM across all users",
    SecondMessage: `If you want to proceed on changing the default time zone please select 'Confirm", otherwise "Discard".`
}

export const DEFAULT_TABLE_RESULT_MODEL = {
    Data: {
        Items: []
    },
    Headers: {},
    Columns: {
        Default: [],
        Available: [],
        Selected: [],
    },
    Pagination: {
        PageNumber: 0,
        PerPage: 10,
        PageSizes: [
            10,
            20,
            30
        ],
        TotalEntries: 0,
        TotalPages: 0,
        HasNext: false,
        HasPrevious: false
    },
    TableFilterData: {
        FilterList: [],
        Operatorlist: [],
        OptionList: [],
    },
    SortedColumnName: "",
    IsSortAscending: true,
    StatusFilter: {
        FirstFilter: 0,
        SecondFilter: 0,
        ThirdFilter: 0,
        FourthFilter: 0,
        TotalFilter: 0,
    },
    ApplyStatusFilter: 0,
    ApplyTabFilter: 0,
}

export const DEFAULT_TABLE_RESULT_EQUIPMENT_DROPDOWN_MODEL = {
    EquipmentTypes : [],
    Vendors: [],
    EquipmentStatuses : [],
    GlCodes: [],
    CostCenters : [],
    Contracts: [],
    CompanyCodes: [],
    IsVIPOption: [],
    CircuitTypes : [],
}

export const TYPE_FUNCTION="function";

export const ACTION_TYPES ={
    Add:"Add",
    Delete:"Delete",
    Update:"Update"
}

export const REPORT_COLUMN_MODULE = {
    CircuitInventoryReport: 1,
    SemiAnnualCostAllocAccrualReport: 2,
    AccrualReportDetails: 3,
    CircuitInventoryManagement: 4,
    ASPUInventoryManagement: 5,
    ASRInventoryManagement: 6,
    EquipmentInventoryManagement: 7,
    OrderRequestManagement: 8,
    DisputeInvoiceManagement: 9,
    InvoiceInvoiceManagement: 10,
    OrderOrderManagement: 11,
    HRManagement: 12,
    RateCardFinanceManagement: 13,
    GLCodeFinanceManagement: 14,
    PlanCatalogueFinanceManagement: 16,
    BillingAccountFinanceManagement: 17,
    DebitorCatalogueRechargeManagement: 18,
    ContractFinanceManagement: 19,
    ArticleCatalogueRechargeManagement: 20,
    RechargingInventoryRechargeManagement: 21,
    CircuitRechargeManagement: 22,
    EquipmentRechargeManagement: 23,
    OTCRechargeManagement: 24,
    OutputConfigurationRechargeManagement: 25,
    OutputRecordRechargeManagement: 26,
    LocationSiteInventoryManagement: 27,
}

export const Selected_Index ={
    i_Zero: "0",
    i_One: "1",
    i_Two: "2",
    i_Three: "3",
    i_Four: "4",
    i_Five: "5",
    i_Six: "6",
    i_Seven: "7",
    i_Eight: "8"
}

export const Allowed_Extension = [
    'CSV', 'XLS', 'XLSX', 'DOCX', 'PDF',
    'TXT', 'ZIP', 'MSG', 'PNG', 'JPG','JPEG',
    'BMP', 'csv', 'xls', 'xlsx', 'docx', 'pdf',
    'txt', 'zip', 'msg', 'png', 'jpg','jpeg','bmp'
]


export const Conf_Message_Allowed_Extension = [
'CSV', 'XLS', 'XLSX', 'DOCX', 'TXT', 'ZIP', 'MSG (email)', 'PNG', 'JPG','JPEG',
    'BMP', 'PDF'
]

export const PDF_Extension ='pdf';

export const BUSINESS_CASE = {
    other: 139
};

export const CIRCUIT_SIM_RANK = {
    Primary: "Primary",
    Secondary: "Secondary"
}

export const SELECT_OPERATOR = {
    Between: "Between",
    Equal: "Equal",
    Not_Equal: "Not Equal"
}

export const EQUIPMENT_TYPE = {
    Device: 1,
    Accessory: 2,
    DeviceName: 'Device',
    AccessoryName: 'Accessory'
}

export const CIRCUIT_STATUS = {
    inService: { id: 1, name: 'In Service' },
    outOfService: { id: 2, name: 'Out of Service' },
    suspended: { id: 3, name: 'Suspended' },
    pending: { id: 4, name: 'Pending' },
}

export const MAX_LENGTH = {
    inputText: 50,
    limit_100: 100,
    limit_500: 500,
    limit_1000: 1000,
    limit_255: 255,
    limit_5: 5,
    limit_15: 15,
    limit_21: 21,
    limit_20: 20,
    limit_10: 10,
    limit_19: 19
}

export const DISPLAY_ITEM = {
    five: 5,
    six: 6,
    seven: 7,
    ten: 10
}

export const REF_CODE_TYPE = {
    URP: 1,
    QRT: 2,
    QCT: 3,
    QRC: 4,
    QRB: 5,
    URL: 6,
    EDP: 7,
    IDP: 8,
    CDRCTT: 9,
    AIGCT: 10,
    MPLS_A: 11,
    MPLS_AB: 12,
    MPLS_EOI: 13,
    MPLS_SP: 14,
    MPLS_CQP: 15,
    MPLS_VN: 16,
    MPLS_SO: 17,
    PTP_SC: 18,
    MPLS_VCS: 19,
    BUS_JUST: 20
}

export const OPTION_LABEL = {
    KEY_VALUE: { Key: 'Key', Value: 'Value' },
    KEY_VALUE_LABEL: { Key: 'Key', Value: 'Value', Label: 'Label' }
};

export const DISPLAY_OPTION = {
    KEY: 'Key',
    VALUE: 'Value',
    LABEL: 'Label'
};

export const PLACEHOLDER = {
    SELECT: "Select..."
    , ENTER_TEXT_HERE: "Enter text here..."
};

export const EQUIPMENT_MSG = {
    CREATED_MSG: "Equipment has been created"
    , UPDATED_MSG: "Equipment has been updated"
    , EXISTS_MSG: "Equipment already exist on the vendor"
    , CONFIRM_UPDATE_MSG: "Are you sure you want to save?"
    , CONFIRM_CREATE_MSG: "Do you want to create new equipment?"
};

export const ORDER_MSG = {
    SUBMITTED_MSG: "Order has been submitted"
};

export const APPROVAL_MESSAGE = {
    ACTION_CONFIRMATION: "Are you sure you want to",
    TARGET_REQUEST: "the order request?",
    APPROVE_REQUEST: "Approve Request",
    REJECT_REQUEST: "Reject Request",
    APPROVE: "approve",
    REJECT: "reject"
}

export const MODAL_TITLE = {
    ERROR: "Error"
    , SUCCESS:"Success"
    , ADD_NEW:"Add New"
    , UPDATE: "Update"
    , SUBMIT_FORM: "Submit Form Request"
    , SAVE: "Save"
    , Colum_Source: "Column Source - Multiple Values"
};

export const DATA_TYPE = {
    decimal: "decimal",
    int: "int",
    float: "float",
    string: "string",
    number: "number"
}

export const REF_SIM_TYPE = {
    standard: { id: 1, name: "Standard" },
    standard4g: { id: 2, name: "Standard - 4G" },
    standardLTE: { id: 3, name: "Standard - LTE" },
    micro: { id: 4, name: "Micro" },
    micro4g: { id: 5, name: "Micro - 4G" },
    microLTE: { id: 6, name: "Micro - LTE" },
    nano: { id: 7, name: "Nano" },
    nano4g: { id: 8, name: "Nano - 4G" },
    nanoLTE: { id: 9, name: "Nano - LTE" },
    scada: { id: 10, name: "SCADA" },
    triCutSIM: { id: 11, name: "Tri-Cut SIM" },
    eSIM: { id: 12, name: "eSIM" }
}

export const ERROR_TYPE = {
    existingServiceType: "ExistingServiceType",
    existingOpenRequestWithServiceType: "ExistingOpenRequestWithServiceType",
    invoiceNumberNotExist: "InvoiceNumberNotExist",
    billedCircuitIdNotExist: "BilledCircuitIdNotExist",
    matchedCircuitIdNotExist: "MatchedCircuitIdNotExist"
}

export const NOTIFICATION_NAME_KEY = {
    operationBusinessHours: "OperationBusinessHours"
}

export const SUBMIT_REQUEST = {
    updateRequest: "Do you want to update this request?",
    submitRequest: "Do you want to submit this request?"
}

export const SUBMIT_REQUEST_TITLE ={
    submitRequest: "Submit Form Request",
    updateRequest: "Update Form Request"
}

export const SERVICE_STATUS = {
    inService : "In Service",
    suspended: "Suspended"
}

export const PROPERTY_NAME = {
    Name : 'Name'
}

export const AUDITRULES_REPORT_HEADERS = {
    InvoiceNum: "Invoice Number",
    BilledCircuitId: " Billed Circuit ID",
    MatchedCircuitCode: "Matched Circuit ID",
    AuditRulesException: "Exception",
    CreatedBy: "Created By",
    DateModified: "Date Modified",
    AuditRulesResultsStatusName: "Status",
    DateCreated:"Date Created ",
    AdditionalInformation: "Additional Information",
    ModifiedBy: "Modified By",
    DisputeCode: "Dispute ID",
    DisputeStatus: "Dispute Status",
  
}

export const  AUDITRULES_REPORT_PROPS = {
    InvoiceNum: "InvoiceNum",
    BilledCircuitId: "BilledCircuitId", 
    DateModified: "DateModified",
    DisputeCode: "DisputeCode",
    MatchedCircuitCode: "MatchedCircuitCode",
    AuditRulesException: "AuditRulesException",
    AuditRulesResultsStatusName: "AuditRulesResultsStatusName",
    AdditionalInformation: "AdditionalInformation",
    ModifiedBy: "ModifiedBy",
    CreatedBy: "CreatedBy",   
    DisputeStatus: "DisputeStatus",
    DateCreated:"DateCreated",
  
  
}
export const INVENTORY_REPORT_HEADERS = {   
    region: "Region",   
    circuitNumber: "Circuit Number",
    vendorName: "Vendor Name",
    circuitCountry: "Circuit Country",
    account: "Account",
    circuitRanking: "Circuit Ranking",
    circuitStatus: "Circuit Status",
    circuitType: "Circuit Type",
    subCircuitStatus: "Sub-Circuit Type",
    pukCode: "PUK Code",
    inServiceDate: "In Service Date",
    cancelledDate: "Cancelled Date",
    dateLeft: "Date Left",
    lastName: "Last Name",
    firstName: "First Name",
    userName: "UserName",
    userHRID: "User HRID",
    userEmailAdd: "User Email Address",
    userVIP: "User VIP",
    costCode: "Cost Code",
    location: "Location",
    userSiteLocation: "User Site Location",
    userCountry: "User Country",
    userCity: "User City",
    prefixCountry: "Prefix Country",
    userJobTitle: "User Job Title",
    hrTeamName: "HR Team Name",
    imei: "IMEI/Serial Number",
    deviceType: "Device Type",
    planName: "Plan Name",
    planComponent: "Plan Component",
    description: "Description",
    baseCost: "Base Cost",
    planComponentCost: "Plan Component Cost",
    totalCost: "Total Cost",
    userLineManager: "User Line Manager",
    lineManagersEmail: "Line Managers Email",
    lmVIP: "LM VIP",
    lineManagerHRID: "Line Manager HRID",
    orderNumber: "Order Number",
    requestType: "Request Type",
    currency: "Currency",
    userStatus: "User Status",
    businessCase: "Business Case",
    simSerialNumber: "SIM Serial Number",
    subscriptionNumber: "Circuit ID",
    userFullName: "Username",
    hrid: "HRID",
    equipmentModel: "Device Type",
    vendor: "Vendor",
    mrc: "Price Component",
}

export const INVENTORY_REPORT_PROPS = {
    region: "Region",
    circuitID: "CircuitId",
    vendor: "Vendor",
    circuitCountry: "CircuitCountry",
    accountNumber: "AccountNumber",
    circuitRanking: "CircuitRanking",
    circuitStatus: "CircuitStatus",
    circuitType: "CircuitType",
    subCircuitType: "SubCircuitType",
    puk: "PUK",
    installDateStr: "InstallDateStr",
    disconnectDateStr: "DisconnectDateStr",
    dateLeftStr: "DateLeftStr",
    lastName: "UserLastName",
    firstName: "UserFirstName",
    userFullName: "UserFullName",
    userHRID: "UserHrId",
    userEmailAdd: "UserEmailAdd",
    userVIP: "UserVIP",
    costCode: "CostCode",
    location: "Location",
    userLocationSite: "UserLocationSite",
    userLocationCountry: "UserLocationCountry",
    userLocationCity: "UserLocationCity",
    prefixCountry: "PrefixCountry",
    userJobTitle: "UserJobTitle",
    hrTeamName: "HrTeamName",
    imei: "IMEI",
    equipmentModel: "EquipmentModel",
    planName: "PlanName",
    planComponent: "PlanComponent",
    description: "Description",
    baseCost: "BaseCost",
    planComponentCost: "PlanComponentCost",
    totalCost: "TotalCost",
    userLineManager: "UserLineManager",
    lineManagerEmail: "LineManagerEmail",
    lmVIP: "LMVip",
    lineManagerHRID: "LineManagerHRID",
    orderNumber: "OrderNumber",
    requestType: "RequestType",
    currency: "Currency",
    userStatus: "UserStatus",
    businessCase: "BusinessCase",
    simSerialNumber: "SIMSerialNumber",
    subscriptionNumber: "SubscriptionNumber",
    mrc: "MRC",
}

export const TABLE_PAGINATION_KEY = {
    inventoryCircuit: "inventory-circuit",
    inventoryASPU: "inventory-aspu",
    inventoryASR: "inventory-asr",
    inventoryEquipment: "inventory-equipment",
    invoiceInvoice: "invoice-invoice",
    invoiceDispute: "invoice-dispute",
    requestAllRequest: "request-all-request",
    requestMyRequest: "request-my-request",
    requestApprovalRequest: "request-approval-request",
    orderOrder: "order-order",
    manageUser: "manage-user",
    rateCard: "rate-card",
    CostCode: "cost-code",
    glCode: "gl-code",
    planCatalogue: "plan-catalogue",
    billingAccount: "billing-account",
    debitorCatalogue: "debitor-catalogue",
    contract: "contract",
    articleCatalogue: "article-catalogue",
    rechargingInventory: "recharging-inventory",
    outputConfiguration: "output-configuration",
    outputRecord: "output-record",
    locationSite: "inventory-location"
}

export const EXTERNAL_LINK_TYPES = {
    userGuide: 1,
    mobilePolicy: 2,
    powerBIReports: 3
}
export const DEFAULT_PAGE_SIZES = [10, 20, 30]

export const DISPUTE_TYPES_TEXT_ID = {
    billingAccountMismatch: "BillingAccountMismatch",
    ceasedButCharging: "CeasedButCharging",
    circuitNotFound: "CircuitNotFound",
    costAllocationNotFound: "CostAllocationNotFound",
    differentProvider: "DifferentProvider",
    discountNotApplied: "DiscountNotApplied",
    invoicePercent: "InvoicePercent",
    mrcMismatch: "MRCMismatch",
    unbilledCircuit: "UnbilledCircuit",
    firstBill: "FirstBill",
    rateCard: "RateCard",
}

export const MILESTONE = [
    "first",
    "second",
    "third",
    "fourth"
]

export const ORDER_MILESTONE = [
    { key: "OrderCreatedModel", label: "order_created", step : 1},
    { key: "OrderSubmittedModel", label: "order_submitted", step: 2},    
    { key: "OrderReceiptConfirmedModel", label: "order_receipt_confirmed", step: 3},
    { key: "CircuitInstalledModel", label: "circuit_installed", step: 4},  
    { key: "OrderRejectedModel", label: "order_rejected", step: 0},
    { key: "OrderCancelledModel", label: "order_cancelled", step: 0 },    
    { key: "OrderCompletedModel", label: "order_completed", step: 4}, 
];

export const ORDER_MILESTONE_LABEL = {
    created: "order_created",
    submitted: "order_submitted",
    confirmed: "order_receipt_confirmed",
    receipt_confirmed: "order_receipt_confirmed",
    rejected: "order_rejected",
    cancelled: "order_cancelled",
    installed: "circuit_installed",
    changed: "circuit_changed",
    disconnected: "circuit_disconnected",
    completed: "order_completed"
}

export const DISMISSAL_STATUSES=[
    {key:"OrderRejectedModel",label: "rejected",id:'13'},
    {key:"OrderCancelledModel",label: "cancelled",id:'12'},  
]

export const ORDER_STATUS_COMPLETED = ['1', '2', '3', '4', '5', '8', '9','10','11']

export const ORDER_NO_FORM_MILESTONE=['order_created','order_rejected']

export const FOLLOWUP_DETAILS=[
    { title: "first_follow_up", textLabel: "first_follow_up_details", dateLabel: "first_follow_up_date", type: "FirstFollowUp" },
    { title: "second_follow_up", textLabel: "second_follow_up_details", dateLabel: "second_follow_up_date", type: "SecondFollowUp" },
    { title: "third_follow_up", textLabel: "third_follow_up_details", dateLabel: "third_follow_up_date", type: "ThirdFollowUp" },
    { title: "fourth_follow_up", textLabel: "fourth_follow_up_details", dateLabel: "fourth_follow_up_date", type: "FourthFollowUp" },
]

export const DISPUTE_HISTORY_OBJ = {
    mrc: "MRC",
    annualPotentialSavings: "Annual Potential Savings",
    annualRealizedSavings: "Annual Realized Savings",
    potentialsavings: "Potential Savings",
    realizedSavings: "Realized Savings"
}

export const ORDER_HISTORY_OBJ = {
    mrc: "MRC",
    price: "Price",
    percent: "Percent", 
}

export const DASHBOARD_LABEL = {
    total: "Total",
    open: "Open",
    inProgress: "In-Progress",
    closed: "Closed",
    rejected: "Rejected",
    pending: "Pending",
    approved: "Approved",
    paid: "Paid",
    completed: "Completed",
    cancelled: "Cancelled",
    mapped: "Mapped",
    unmapped: "Unmapped",
    mismatched: "Mismatched"
}

export const DEFAULT_PAGE_VALUE = {
    "PageNumber": 0,
    "PerPage": 10,
    "TotalPages": 1,
    "TotalEntries": 1,
    "HasNext": true,
    "HasPrevious": false,
    "PageSizes": [
        10,
        20,
        30
    ]
}

export const UPLOAD_NOTIFICATION_MESSAGE={
    RemoveFile:"Are you sure you want to remove the attached file?"
}


export const INVOICE_STATUS = {
    NotExpectedInvoice: 1,
    NotReceived: 2,
    Requested: 3,
    ProcessedSentToAP: 4,
    Processed: 5,
    Rejected: 6,
    Escalated: 7,
    Submitted: 8,
    ForAudit: 9,
    Paid: 10
}

export const MODAL_CUSTOM_TITLE={
    Confirmation:"Confirmation",
    Notification:"Notification",
    Error:"Error",
    MapInventory:"Map Inventory",
    OutputGeneration: "Recharging Output Generation"
}

export const MODAL_CUSTOM_MESSAGE={
    delete: "Are you sure you want to delete?",
    match_audit_confirmation: "Are you sure you want to perform the selected audit rules?",
    match_audit_notification: "Match/Audit will now run on background. Please check the notification for status",
    upload_notification: "The upload progress will now run on background. Please check the notification for the upload status",
    maximum_files: "Exceeded number of maximum files",
    invalid_file_type: "Invalid file type",
    exception_confirmation: "Are you sure you want save?",
    order_cancel_approve: "The order is either cancelled or not approved",
    order_completing_request: "Populate all required fields before completing the request",
    export_alert_message: "Please confirm that the harvesting of data and its usage has been approved by the client.",
    create_new_cost_center: "Do you want to create new cost center?",
    create_new_gl_code: "Do you want to create new GL code?",
    create_new_hr_user: "Do you want to create new HR/User?",
    create_new_plan: "Do you want to create new plan?",
    create_new_billing: "Do you want to create new billing account?",
    update_details: "Are you sure you want to update?",
    add_details: "Are you sure you want to add?",
    circuit_already_exist: "Circuit ID already exist",
    create_new_billing_account: "Do you want to create new Billing Account?",
    create_new_debitor: "Do you want to create new Debitor?",
    create_new_contract: "Do you want to create new Contract?",
    create_new_article: "Do you want to create a new Article?",
    create_new_recharging_equipment: "Do you want to create a new Equipment Recharging Inventory?",
    create_new_recharging_otc: "Do you want to create a new OTC Recharging Inventory?",
    create_new_recharging_circuit: "Do you want to create a new Circuit Recharging Inventory?",
    clear_formula: "Do you want to clear the Client Formula?",
    mapping_confirmation: "Do you want to map recharging information to the inventory?",
    create_new_output_configuration: "Do you want to create a new Output Configuration?",
    mapping_notification: "The mapping process will now run on background. Please check the notification for the mapping status.",
    multiple_soruce_column: "Are you sure to create a column with multiple source?",
    output_record_delete: "Deleting will remove this record to the Output record. Would you like to continue?",
    clear_output_record: "Selected Recharge Items will be removed to the Recharged records. Would you like to continue?",
    output_record_generate_record: "Generating Output Record will now run on the background. Please check the notification for output record generation status",
    output_record_notification: "This would generate an Output Record file and commit Output Record ID to the database. Would you like to continue?",
    multiple_source_invalid_empty_validation: "Invalid or empty values.",
    multiple_source_empty_bracket_validation: "Empty brackets [] are not allowed. Please check the Column source keyword on Column Values field: []",
    multiple_source_invalid_bracket_validation: "Invalid bracket usage. Please check the Column source keywords are properly enclosed.",
    multiple_source_invalid_column_source_keyword_validation: "Please check the Column source keyword on Column Values field: ",
    multiple_source_multiple_column_source_keyword_validation: " was used more than once. Column Source(s) should only be used once within the string.",
    multiple_source_single_source_validation: "Column Values should use the multiple column sources as intended. You can consider using the single column source on Details page.",
    multiple_source_open_closed_bracket_validation: "Column Source(s) should be enclosed in an open and closed bracket.",
    multiple_source_spaces_validation: "Spaces are not allowed outside of Column source keywords.",
    multiple_source_invalid_character_validation: "Column Values field contain invalid characters.",
    output_record_already_exist: "Same record already exists.",
    output_record_30_exeed_validation: "Output Columns already exceed 30 records. Unable to add any more records.",
    multiple_source_to_output_column_update: "Multiple Column Source has been updated in the Output Columns Table.",
    multiple_source_to_output_column_add: "Multiple Column Source has been added in the Output Columns Table.",
    generate_output_confirmation: "Are you sure you want to generate an output?",
    generate_output_notification: "Recharging process will now run on background. Please check the notification for the output status.",
    remove_credit_card_info: "Are you sure you want to remove credit card info?",
    requestor_owner_required: "Requestor and Owner fields are required to complete the request",
}

export const INVOICE_NOTIFICATION_STATUS={
    completed: {
        key: "Completed", value: "Completed"
    },
    failed: {
        key: "Failed", value: "Failed"
    },
    inProgress: {
        key: "InProgress", value: "In Progress"
    },
    pending : {
        key: "Pending", value: "Pending"
    },
    completedwitherror : {
        key: "CompletedWithError", value: "Completed With Error"
    }
}

export const ROUTE_LINK_LOCATION = {
    invoiceRouteLink: "/external/invoice/linked-invoice",
    circuitRouteLink: "/external/inventory/linked-circuit",
    inventoryCircuitLink: "/external/Inventory/matched-circuit/",
    invoiceDisputeLink: "/external/Invoices/Disputes",
    invoiceDisputeDetailsLink:"/external/Invoices/Disputes/DisputeDetails",
    invoiceDisputeCreateNewLink:"/external/Invoices/Disputes/New",
    invoiceDisputeCreateNewInvoiceAuditLink: "/external/Invoices/Disputes/InvoiceAudit",
    invoiceDashboard: "/external/Invoices/Invoices",
    invoiceUpload: "/external/Invoices/InvoiceUpload",
    orderDetailsRouteLink: "/external/Orders/Orders/OrderDetails/Order/",
    hrManagerLink: "/external/HrManagement/ManageHR",
    inventoryOrderHistoryLink: "History/MyRequest/RequestDetail/Order/",
    orderRecords: "/external/Recharging/OutputConfiguration",
    orderId: ":id",
    qoutationId: ":id",
    inventoryCreateCircuitLink: "/external/Inventory/Circuit/New",
    inventoryCircuitDashboard: "/external/Inventory/Circuit"
}

export const AUDIT_MODAL_TITLE={
    AuditRules:"Audit Rules",
    CircuitNotFound: "Circuit Not Found"
}

export const AUDIT_GRAPH_TITLE= [
   "Valid Exception",
   "Invalid Exception"
]

export const AUDIT_KEY={
    "DisputeId":"DisputeId",
    "CircuitId":"CircuitId",
    "Exception": "Exception",
    "MatchedCircuitCode": "MatchedCircuitCode",
    "DisputeCode": "DisputeCode",
}

export const AUDIT_LEDGER ={
     valid:[
        {color:'#004c6d'}, 
        {color:'#205e7e'}, 
        {color:'#357090'},
        {color:'#4983a2'},
        {color:'#5d97b4'},
        {color:'#71abc6'},
        {color:'#85bfd9'},
        {color:'#99d4ec'},
        {color:'#aee9ff'},    
    ],  
    invalid:[
        {color:'#e98c01'}, 
        {color:'#ea9c29'}, 
        {color:'#ebab43'},
        {color:'#edb95b'},
        {color:'#efc774'},
        {color:'#f2d48d'},
        {color:'#f5e1a6'},
        {color:'#f9edbf'},
        {color:'#fff9d9'},   
    ]
}

export const LABEL_FORMAT= {
    "ExceptionDetails": 'exception_details',
    "DateCreated": 'date_created',
    "DateModified": 'date_modified',
    "CreatedBy": 'created_by',
    "ModifiedBy": 'modified_by',
    "InvoiceNumber": 'invoice_number',
    "AccountNumber": 'account_number',
    "BilledCircuitId": 'billed_circuit_id',
    "BilledAmount": 'billed_amount',
    "DisputeId": 'dispute_id',
    "DisputeStatus": 'dispute_status',
    "PotentialSavings": 'potential_savings',
    "RealizedSavings": 'realized_savings',
    "MatchedCircuitId": 'matched_circuit_id',
    "MRC": 'mrc',
    "MatchedCircuitIdAccountNumber": 'matched_circuit_id_account_number',
    "AllocationLevel": 'allocation_level',
    "CircuitStatus": 'circuit_status',
    "DisconnectDate": 'disconnect_date',
    "CurrentTotalAmountDue": 'current_total_amount_due',
    "PreviousTotalAmountDue": 'previous_total_amount_due',
    "Difference": 'difference',
    "PercentageChange": 'percentage_change',
    "InstallDate": 'install_date',
    "InvoiceDetails": "invoice_details",
    "DisputeDetails": "dispute_details",
    "RecurringCharges": "recurring_charges",
    "User": 'user',
    "Status": 'status',
    "ChargeType": 'charge_type',
    "RateCardName": 'rate_card_name',
}

export const AUDIT_RULES = [
    { value: "Select All", 
      key:"SelectAll",     
      tooltip: "Selects all rules" },
    { value: "Circuit Not Found", 
      key: "CircuitNotFound",
      id: 1,
      disabled:true,
      tooltip: "Check if there is a matching Circuit ID on the Circuit Inventory for the Invoice Billed Circuit ID/Line Item" 
    },
    { value: "Billing Account Mismatch",
      key:"BillingAccountMismatch", 
      id: 2,
      tooltip: "Check if the Billing Account Number of the invoice matches the Billing Account Number of the Circuit ID on the Circuit Inventory" 
    },
    { value: "Ceased But Charging", 
      key:"CeasedButCharging",
      id: 3,
      tooltip: "Check if the status of the Matched Circuit ID on the Circuit Inventory is \"Out of Service\"" },
    { value: "Cost Allocation Not Found", 
      key:"CostAllocationNotFound",
      id: 4,
      disabled:true,
      tooltip: "Check if the cost allocation details for the invoice is complete based on the Billing Account Number Allocation Level" 
    },
    { value: "First Bill", 
      key: "FirstBill",
      id: 5,
      tooltip: "Check if the circuit/mobile number is billed for the first time" 
    },
    { value: "Invoice Percent", 
      key: "InvoicePercent",
      id: 6,
      tooltip: "Check if the Total Amount Due of the invoice is within 20% tolerance rate from the Total Amount Due of the previous invoice" },
    { value: "MRC Mismatch", 
      key: "MRCMismatch",
      id: 7,
      tooltip: "Check if the MRC (Monthly Recurring Charges = Recurring Charges + Recurring Credits on the Subline Item)  of the Billed Circuit ID/Line Item matches the MRC of the Circuit ID on the Circuit Inventory" },
    { value: "Unbilled Circuit", 
      key: "UnbilledCircuit",
      id: 8,
      tooltip: " Check if there is an \"In Service\" Circuit ID on the Circuit Inventory under the Billing Account Number of the invoice that are not billed on the invoice" },
    { value: "Rate Card", 
      key: "RateCard",
      id: 9,
      tooltip: " Check if rate charged per usage charges of invoice line item matches the contract rate based on Rate Card" }
];


export const CIRCUIT_NOT_FOUND = {
    circuitNotFound: "Circuit Not Found"
}



export const AUDIT_NOTE = {
    auditNote: "Note: This invoice is not yet matched to inventory. You may access Match/Audit function in AUDIT tab"
}

export const DEFAULT_SUBLINE_ITEM_CHARGE_TYPE = {
    barChart: [
        { name: "Domestic Fixed Calls", RoamingVoice: 800 },
        { name: "Roaming Data", RoamingData: 798 },
        { name: "Domestic Mobile Calls", DomesticMobileCalls: 632 },
        { name: "Internation Fixed Calls", InternationFixedCalls: 700 },
        { name: "Premium Calls", PremiumCalls: 543 },
        { name: "Roaming Voice", RoamingVoice: 768 }
    ],
}

export const TABLE_NO_LINK_DATA =[
    "Circuit Not Found"
]

export const TABLE_WARNING_ICON={
    AUDIT_TABLE:{
        columnName:"AuditRulesResultsStatusName",
        warningCondition :"AuditRulesResultsStatusInvalidFlag",
        tooltip: "This exception can now be tagged as Invalid"
    }
}

export const AUDIT_EXCEPTION = {
    billingAccountMismatch: "Billing Account Mismatch",
    ceasedButCharging: "Ceased But Charging",
    circuitNotFound: "Circuit Not Found",
    costAllocationNotFound: "Cost Allocation Not Found",
    invoicePercent: "Invoice Percent",
    mrcMismatch: "MRC Mismatch",
    unbilledCircuit: "Unbilled Circuit",
    firstBill: "First Bill",
    rateCard: "Rate Card"
}

export const INVOICE_HANDLER = {
    verizonwireless: 229,
    attmobility2: 37,
    tmobile: 40,
    generichandler: 103,
    attmobilityall: 101,
    polkomtel: 24,
    o2: 91,
    bouygues: 89,
    wavenet: 225
}

export const INVOICE_HANDLER_NAME = {
    swisscom: "Swisscom (CH)",
    vodafoneit : "Vodafone (IT)"
}

export const DEFAULT_EXCEPTION_DETAILS = {
    AuditRulesDetails: {
        Exception: [],
        Invoice: [],
        Dispute: [],
    },
}

export const FILE_NAME_TEMPLATE = {
    genericTempalte: "Generic Handler Template.xlsx",
    genericOcrTemplate: "Generic Handler (OCR) Template.xlsx",
    chargeMappingTemplate: "BOBST - Charge Mapping Template.xlsx",
    rateCardUploadTemplate: "BOBST - Rate Card Template.xlsx",
    debitorUploadTemplate: "Debitor Catalogue Template.xlsx",
    hrUploadTemplate: "HR Upload Template.xlsx",
    articleCatalogueTemplate: "Article Catalogue Template.xlsx"
}

export const DOWNLOAD_TEMPLATE_lABEL = {
    generic_template: "Download Generic Template",
    charge_mapping: "Download Charge Mapping Template",
    rate_card_upload: "Download Rate Card Template",
    hr_upload: "Download HR Upload Template",
    article_catalogue: "Download Article Catalogue Template",
    debitor_catalogue: "Download Debitor Catalogue Template",
    inventory_upload: "Download Inventory Template",
}

export const UPLOAD_TYPES = {
    HrUpload: 1,
    InventoryDeltaUpload: 2,
    PricePlanUpload: 3,
    CurrencyUpload: 4,
    InvoiceUpload: 5,
    ChargeTypeUpload: 6,
    GLCodeUpload: 10,
    CostCenterUpload: 11,
    FinanceAccountUpload: 12,
    FinanceCostAllocationUpload: 13,
    InventoryCostAllocationUpload: 14,
    APUpload: 15,
    EquipmentUpload: 16,
    InvoiceMatchAudit: 17,
    RateCardUpload: 18,
    DebitorUpload: 19,
    ArticleUpload: 20,
    CircuitWireless: 21,
    CircuitEquiment: 22,
    CircuitSim: 23,
    CircuitPlanDetail: 24,
    CircuitCostAllocation: 25,
    CircuitStatus: 26,
    InventoryEquipment: 27,
    RechargeMappingInventory: 28,
    RechargingOutputGeneration: 29,
    RechargingOutputRecordGeneration: 30
};

export const CHARGE_MAPPING_UPLOAD_TYPES = {
    New: 1,
    Add: 2
};

export const CHARGE_MAPPING_FILE_LIMITATION= {
    maxFiles: 1,
    minFiles: 1,
    acceptedFiles: ".xlsx",
};

export const DEBITOR_UPLOAD_TYPES_ID = {
    New: 1,
    AddUpdate: 2
};

export const DEBITOR_UPLOAD_TYPES_MESSAGE = {
    New: "Note: Upload type = New will replace all the existing Debitors uploaded",
    AddUpdate: "Note: Upload type = Add/Update will add newly included Debitors and update existing Debitors if there is/are change(s)"
}

export const DEBITOR_UPLOAD_FILE_LIMITATION = {
    maxFiles: 1,
    minFiles: 1,
    acceptedFiles: ".xlsx",
};

export const RATE_CARD_UPLOAD_TYPES = {
    New: 1,
    Add: 2
};

export const RATE_CARD_UPLOAD_TYPE_MESSAGE = {
    New: "Note: Upload type = New will replace all the existing rate card uploaded",
    Add: "Note: Upload type = Add will only add the uploaded data on the current set of rate card"
};

export const RATE_CARD_FILE_LIMITATION = {
    maxFiles: 1,
    minFiles: 1,
    acceptedFiles: ".xlsx",
};

export const EXCEPTION_STATUS = {
    valid: { id: 1, name: 'Valid' },
    invalid: { id: 2, name: 'Invalid' },
}

export const DEFAULT_TABLE_RESULT_COST_CENTER_DROPDOWN_MODEL = {
    Authorizer : [],
    Currency: [],
    Status: [],
}

export const COST_ALLOCATION_TYPE = {
   GlCode: "glCode"
}

export const REQUEST_TYPE_MILESTONE = 
{
    simple: "Simple",
    disconnect : "Disconnect",
    change : "Change"
}

export const REQUEST_TYPES = 
{
    newMobileSubscription: "New Mobile Subscription",
    portIn: "Port-In",
    accessory: "Accessory",
    changeVendor: "Change Vendor",
    replaceOrUpgradeDevice: "Replace/Upgrade Device",
    terminateSubscription: "Terminate Subscription",
    portOut: "Port-Out",
    changeUser: "Change User",
    intlRoamAccess: 'International Roaming Access',
    other: 'Other',
    changeNumber: 'Change Number',
    enableHotspot: 'Enable Hotspot',
    simActivation: 'SIM Activation',
    suspendResumeService: 'Suspend/Resume Service',
    pukCode: 'PUK Code',
    otherSIMReplacement: 'SIM Replacement',
    otherChangeOfPlan: 'Change of Plan',
    callingAccess: 'Calling Access',
    roamingAccess: 'Roaming Access',
    terminateSubscriptionWireline: 'Terminate Circuit',
    wirelineChangeVendor: 'Change Vendor (Wireline)',
    newCircuit: 'New Circuit',
    newQuotation: 'New Quotation',
    updatePlan: 'Update Plan',
    simAndDevice: 'SIM and Device',
    newMobileDevice: 'New Mobile Device',
    wifiDongleAndDataCard: 'Wifi Dongle and Data Card',
    simAndDeviceBSA: 'SIM and Device (BSA)',
    simOnlyBSA: 'SIM only (BSA)',
    multiSIMBSA: 'Multi SIM (BSA)',
    wifiDongleAndDataCardBIN: 'Wifi, Dongle and Data Card (BIN)',
    voiceSIMBIN: 'Voice SIM (BIN)',
    wifiDongleDataCardAndVoiceSIMBIN: 'Wifi Dongle, Data Card and Voice SIM (BIN)'
}

export const ORDER_EQUIPMENT_STATUS = {
    inService: "1",
    outOfService: "2"
}

export const MILESTONE_FORM_VALIDATION = {
    newMobileSubscription: "New Mobile Subscription",
    portIn: "Port-In",
    accessory: "Accessory",
    changeVendor: "Change Vendor",
    replaceOrUpgradeDevice: "Replace/Upgrade Device",
    terminateSubscription: "Terminate Subscription",
    portOut: "Port-Out",
    changeUser: "Change User",
    intlRoamAccess: 'International Roaming Access',
    other: 'Other',
    changeNumber: 'Change Number',
    enableHotspot: 'Enable Hotspot',
    simActivation: 'SIM Activation',
    suspendResumeService: 'Suspend/Resume Service',
    pukCode: 'PUK Code',
    otherSIMReplacement: 'SIM Replacement',
    otherChangeOfPlan: 'Change of Plan',
    callingAccess: 'Calling Access',
    newQuotation: 'New Quotation',
    updatePlan: 'Update Plan',
    roamingAccess: 'Roaming Access',
    newCircuit: 'New Circuit',
    newQuotationRequest: 'New Quotation Request',
    upgradeQuotationRequest: 'Upgrade Quotation Request',
    terminateCircuit: 'Terminate Circuit',
    simAndDevice: 'SIM and Device',
    newMobileDevice: 'New Mobile Device',
    wifiDongleAndDataCard: 'Wifi Dongle and Data Card',
    simAndDeviceBSA: 'SIM and Device (BSA)',
    simOnlyBSA: 'SIM only (BSA)',
    multiSIMBSA: 'Multi SIM (BSA)',
    wifiDongleAndDataCardBIN: 'Wifi, Dongle and Data Card (BIN)',
    voiceSIMBIN: 'Voice SIM (BIN)',
    wifiDongleDataCardAndVoiceSIMBIN: 'Wifi Dongle, Data Card and Voice SIM (BIN)'
}

export const QUOTATION_CODE_DETAIL = {
    newQuotation: "New Quotation Request",
    upgradeQuotation: "Upgrade Quotation Request"
}

export const PLAN_COMPONENT_PROPNAME = [
    "ComponentName",
    "ComponentDetails",
    "ComponentCost"
]

export const NUMBER_TYPE_FIELDNAME = [
    "ComponentCost",
    "Percent",
    "CostCodePercent"
]

export const DEFAULT_TABLE_RESULT_DEBITOR_CATALOGUE_DROPDOWN_MODEL = {
    Country: [],
    Currency: [],
    SalesOrganization: [],
    VatGroup: []
}

export const VAT_GROUP = {
    Yes: 1,
    No: 2
}

export const DEFAULT_TABLE_RESULT_FINANCE_CONTRACT_DROPDOWN_MODEL = {
    ContractStatus: [],
    EvergreenStatus: [],
    ServiceType: [],
    Vendor: []
}

export const TWO_COLUMN_UPLOAD_COLUMN = {
    debitorUplaod : 19,
    articleUpload: 20,
    rechargingMappingInventory: 28,
}

export const HR_UPLOAD_TYPE_MESSAGE = {
    Bulk: "Note: Upload type = Bulk operation refers to the ability to process multiple records at once, making it easier to add or update large volumes of data in a single action. It will deactivate all employees who are not part of the uploaded template. Please consider performing the upload around weekends or outside of business hours to minimize system disruption.",
    Add: "Note: Upload type = The Add operation is used to insert new active records into the system, typically for employees or data entries that do not yet exist in the database.",
    Update: "Note: Upload type = The Update operation is used to modify or change existing records in the system, such as updating employee details."
};

export const HR_UPLOAD_FILE_LIMITATIONS = {
    maxFiles: 1,
    minFiles: 1,
    acceptedFiles: ".xlsx",
};

export const HR_UPLOAD_TYPES = {
    Bulk: 1,
    Add: 2,
    Update: 3
};

export const HR_UPLOAD_TEMPLATE_ERRORS = [
    "Duplicate Email",
    "Duplicate HRID",
    "Duplicate Username",
    "Invalid Characters",
    "Invalid Code",
    "Invalid Date",
    "Invalid Format",
    "Invalid Input",
    "Invalid Status",
    "Invalid Value",
    "Past Date",
    "Required Field",
    "Line Manager Doesn't Exist"
];

export const WORKFLOW_MESSAGE = {
    approvalWorkFlow: "Note: Changes on approval workflow will only be applied to new order request. Approval of existing order request will NOT be updated.",
    refreshMappingWorkflow: "Note: This Recharging Inventory has Incomplete/Mismatched Mapping Status. Please verify the Mapping Information field values and update accordingly."
}

export const ARTICLE_UPLOAD_TYPE_MESSAGE = {
    New: "Note: Upload type = New will replace all the existing Article Record",
    AddUpdate: "Note: Upload type = Add/Update will add newly included Articles and update existing Articles if there is/are change(s)",
};

export const ARTICLE_UPLOAD_TYPES = {
    New: 1,
    AddUpdate: 2
};

export const ARTICLE_UPLOAD_FILE_LIMITATIONS = {
    maxFiles: 1,
    minFiles: 1,
    acceptedFiles: ".xlsx",
};

export const DEFAULT_TABLE_RESULT_ARTICLE_CATALOGUE_DROPDOWN_MODEL = {
    ChargeCategory: [],
    ChargeType: [],
    CountryCode: [],
    PriceCalculation: [],
    SalesOrganization: [],
    VatGroup: []
}

export const ARTICLE_COMPONENT_INITIAL_DATA = [
    { Key: 0, RateComponent: "PASS_THRU", Category: "PASS_THRU", Amount: null, Percent: null },
    { Key: 1, RateComponent: "COUNTRY_VAT", Category: "COUNTRY_VAT", Amount: null, Percent: null },
    { Key: 2, RateComponent: "HW_FEE", Category: "HW_FEE", Amount: "0.00", Percent: null }
];

export const ARTICLE_COMPONENT_HEADER = [
    {
        RateComponent: { propName: "RateComponent", name: "Rate Component", hidden: false },
        Category: { propName: "Category", name: "Category", hidden: false },
        Amount: { propName: "Amount", name: "Amount", hidden: false },
        Percent: { propName: "Percent", name: "Percent", hidden: false }
    }
];

export const ARTICLE_FORMULA_LABELS = {
    ConstantFormula: "*(1 + [COUNTRY_VAT] + [HW_FEE])",
    Note: "Note: The pre-defined [COUNTRY_VAT] component is already included in the recharging computation.",
};

export const INVENTORY_TEMPLATE = [
    {
      category: "Circuit",
      templates: [
        { key:17, id: "circuit_wireless", label: "Circuit (Wireless)", fileName: "Circuit (Wireless) Template.xlsx"},
        { key:18, id: "circuit_equipment", label: "Circuit Equipment", fileName: "Circuit Equipment Template.xlsx"},
        { key:19, id: "circuit_sim", label: "Circuit Sim", fileName: "Circuit Sim Template.xlsx"},
        { key:20, id: "circuit_plan", label: "Circuit Plan Detail", fileName: "Circuit Plan Details Template.xlsx"},
        { key:21, id: "circuit_cost", label: "Circuit Cost Allocation", fileName: "Circuit Cost Allocation Template.xlsx"},
        { key:22, id: "circuit_status", label: "Circuit Status", fileName: "Circuit Status Template.xlsx"}
      ]
    },
    {
      category: "Equipment",
      templates: [
       { key:23, id: "equipment", label: "Equipment", fileName: "Equipment Template.xlsx"}
      ]
    }
];

export const INVOICE_TEMPLATE = {
    extractOption: [
        {
            "id": 0,
            "label": "Generic Handler"
        },
        {
            "id": 1,
            "label": "Generic Handler (OCR)"
        }
    ]
}

export const INVENTORY_UPLOAD_FILE_LIMITATIONS = {
    maxFiles: 1,
    minFiles: 1,
    acceptedFiles: ".xlsx",
};

export const INVENTORY_UPLOAD_TYPE_MESSAGE = {
    CircuitWireless: "Note: Upload type = Add/Update - Circuit (Wireless) operation refers to processing multiple wireless circuit records at once. Ensure all data is accurate before uploading.",
    CircuitEquiment: "Note: Upload type = Update - Circuit Equipment operation refers to processing multiple circuit equipment records at once. Verify equipment details before uploading.",
    CircuitSim: "Note: Upload type = Update - Circuit Sim operation refers to processing multiple circuit SIM records at once. Ensure SIM data is accurate before uploading.",
    CircuitPlanDetail: "Note: Upload type = Update - Circuit Plan Detail operation refers to processing multiple circuit plan records at once. Double-check plan details before uploading.",
    CircuitCostAllocation:"Note: Upload type = Update - Circuit Cost Allocation operation refers to processing multiple circuit cost allocation records at once. Verify cost details before uploading.",
    CircuitStatus: "Note: Upload type = Update - Circuit Status operation refers to processing multiple circuit status updates at once. Verify status changes before uploading.",
    InventoryEquipment: "Note: Upload type = Add/Update - Equipment operation refers to processing multiple equipment records at once. Ensure all equipment data is accurate before uploading."
}

export const RECHARGING_TAB_TYPE = {
    all: { id: 0, name: "All" },
    circuit: { id: 1, name: "Circuit" },
    equipment: { id: 2, name: "Equipment" },
    otc: { id: 3, name: "OTC" }
}

export const DEFAULT_TABLE_RESULT_RECHARGE_INVENTORY_DROPDOWN_MODEL = {
    EquipmentType: [],
    OperationalStatus: [],
    Vendor: [],
    EndUser: [],
    Requestor: [],
    RechargingPerson: [],
    Location: [],
    OTCType: [],
    LocationId: [],
    CircuitType: [],
    OrderType: [],
    Costcenter: [],
    VatGroup: [],
    PriceCalcutlation: []
};

export const  
    FiveDecimalPlaces = 5;

export const RECHARGE_INVENTORY_TYPE = {
    Circuit: {id: 1, label: "Circuit"},
    Equipment: {id: 2, label: "Equipment"},
    OTC: {id: 3, label: "OTC"}
}

export const NOTIFICATION_HAVE_EXTRACT = {
    CircuitWireless: 21,
    RechargingOutputGeneration: 29,
}

export const HAS_LIST_TAB = {
    CircuitWireless: 21,
    rechargingMappingInventory: 28,
    RechargingOutputGeneration: 29,
    RechargingOutputRecordGeneration: 30
}

export const FILE_DELIMITER = {
    xls: { id: 1, delimiter: "none" },
    csv: { id: 2, delimiter: "comma" },
    txt: { id: 3, delimeter: "tab"}
}

export const OPERATOR_FILTERS = {
    textbox: { filterType: "Textbox", Operators: ["Contains", "Does Not Contain", "Equal", "Not Equal"] },
    date: { filterType: "Date Range", Operators: ["Between", "Equal", "Not Equal"] }
}

export const COLUMN_DATA_TYPE = {
    text: { id: 1, type: "Text", defaultId: 1 },
    date: { id: 2, type: "Date", defaultId: 5 },
    decimal: { id: 3, type: "Decimal", defaultId: 13}
}

export const OUTPUT_SCOPE_TYPE = {
    circuit: { id: 1, name: "Circuit" },
    equipment: { id: 2, name: "Equipment" },
    otc: { id: 3, name: "OTC" }
}

export const OUTPUT_COLUMN_TYPE = {
    OutputColumn: { id: 4, name: "OutputColumn" },
    MultipleOutputColumn: { id: 5, name: "MultipleOutputColumn" },
}

export const OUTPUT_COLUMN_SOURCE = {
    FeederSystem: { id: 1, name: "Feeder System" },
    RechargingInventoryType: { id: 2, name: "Recharging Inventory Type" },
    DDI: { id: 3, name: "DDI" },
    Type: { id: 4, name: "Type" },
    Vendor: { id: 5, name: "Vendor" },
    Date: { id: 6, name: "Date" },
    EndUser: { id: 7, name: "End User" },
    Requestor: { id: 8, name: "Requestor" },
    RechargingPerson: { id: 9, name: "Recharging Person" },
    RechargingQuantity: { id: 10, name: "Recharging Quantity" },
    RechargingAmount: { id: 11, name: "Recharging Amount" },
    ServiceInstanceID: { id: 12, name: "Service Instance ID" },
    CustomerTag: { id: 13, name: "Customer Tag" },
    ArticleNumber: { id: 14, name: "Article Number" },
    ArticleName: { id: 15, name: "Article Name" },
    DebitorNumber: { id: 16, name: "Debitor Number" },
    DebitorName: { id: 17, name: "Debitor Name" },
    CostCenter: { id: 18, name: "Cost Center" },
    SalesOrganizationNumber: { id: 19, name: "Sales Organization Number" },
    VATGroup: { id: 20, name: "VAT Group" },
    PriceCalculation: { id: 21, name: "Price Calculation" },
    AdditionalAttribute: { id: 22, name: "Additional Attribute" },
    ServiceDate: { id: 23, name: "Service Date" },
    InvoiceNumber: { id: 24, name: "Invoice Number" },
    LineItemID: { id: 25, name: "Line Item ID" },
    Currency: { id: 26, name: "Currency" },
    LocationID: { id: 27, name: "Location ID" },
    CreationDate: { id: 28, name: "Creation Date" },
    CreatedBy: { id: 29, name: "Created By" },
    None: { id: 30, name: "None" },
    MultipleColumnSource: { id: 31, name: "Multiple Column Source" },
};

export const OPERATOR_FILTER_ENUMS = {
    "Equal": "Equal",
    "Not Equal": "NotEqual",
    "Contains": "Contains",
    "Does Not Contain": "DoesNotContain",
    "Between": "Between"
};

export const CLIENTID = {
    bobst: 1
}